import type { InstallIso } from '@/api/types'
import type { Tone } from '@/domain/lease'

// 설치 ISO 화면이 보이는 상태. API 의 state 에 등록 기한과 옛 판 여부를 겹친 것이 전부다:
// ready 라도 expires_at 이 지났으면 그 이미지로는 더 이상 장비를 등록할 수 없으므로 `만료`고,
// 지금의 굽기가 만들지 않는 이미지(outdated)는 설치기가 바뀐 것이라 `옛 판`이다.

export type IsoStatus = InstallIso['state'] | 'expired' | 'outdated'

export function isoStatus(iso: InstallIso, now: number): IsoStatus {
  if (iso.state === 'ready') {
    const at = Date.parse(iso.expires_at)
    if (Number.isFinite(at) && at <= now) return 'expired'
    if (iso.outdated) return 'outdated'
  }
  return iso.state
}

export const ISO_WORD: Record<IsoStatus, { label: string; tone: Tone }> = {
  pending: { label: '생성 대기', tone: 'none' },
  building: { label: '생성 중', tone: 'none' },
  ready: { label: '사용 가능', tone: 'ok' },
  failed: { label: '생성 실패', tone: 'danger' },
  expired: { label: '만료', tone: 'warn' },
  outdated: { label: '옛 판', tone: 'warn' },
}

export const ISO_PROGRESS_WORD: Record<InstallIso['progress']['stage'], string> = {
  queued: '대기',
  source: '원본 준비',
  preparing: '설치 ISO 구성',
  verifying: '설치 ISO 확인',
  finalizing: '마무리',
  complete: '완료',
}

/** 다시 만들어야 다음 장비를 설치할 수 있는 상태. */
export function isoNeedsRebuild(status: IsoStatus): boolean {
  return status === 'failed' || status === 'expired' || status === 'outdated'
}
